import { useMutation } from '@tanstack/react-query'
import AXIOS_INSTANCE from '../api/axiosInstance'
import { queryClient } from '../store/provider/TanStackProvider'

type Payload = {
  data: {
    type: string
    attributes: {
      note: string
      addendumable_id: string
      addendumable_type: string
    }
  }
}
export const useAddendum = () => {
  const { mutateAsync: addAddendum } = useMutation({
    mutationFn: async (payload: Payload) => {
      const { data } = await AXIOS_INSTANCE.post('addendums', payload, {
        headers: { 'Content-Type': 'application/vnd.api+json' }
      })
      return data
    },
    onSuccess: (_, { data: { attributes } }) => {
      queryClient.invalidateQueries({
        queryKey: [attributes.addendumable_type.toLowerCase(), { id: attributes.addendumable_id }]
      })
      queryClient.invalidateQueries({
        queryKey: [attributes.addendumable_type.toLowerCase()]
      })
    }
  })

  return {
    addAddendum
  }
}
